//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getCategories(query) {
    // console.log("products -> query", query);
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/product/category/list${objectToQueryString(query)}`, //
        // content: request,
    });
}
export { 
// ISignInRequest,
getCategories, };
